// import { CarrierBody } from '../../types/carrier'
import { PassengerCodes } from '../../types/passenger'
import { message } from 'antd'
export const validUrl = (url: string) => /^(https*|www\.)/gi.test(url);

export const redirect = (url: string) => {
  if (validUrl(url)) {
    window.location.href = url; 
  } else {
    if (url) {
      if (url?.[0] === "/") {
        window.location.href = `${url}`;
      } else {
        window.location.href = `/${url}`;
      }
    } else {
      window.location.href = "/";
    }
  }
};

const defaultImg =
  "data:image/png;base64,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";
export const getImgUrl = (url: string) =>
  url
    ? validUrl(url)
      ? url
      : `${process.env.REACT_APP_ASSETS}${url}`
    : defaultImg;

export const getPage = (query: string) => {
  const page = new URLSearchParams(query || window.location.search);
  return parseInt(page.get("page") as any);
};

export const getParamValue = (query?: string, field?: string) => {
  const page = new URLSearchParams(query || window.location.search);
  return field ? page.get(field) : page.getAll(field as any);
};
export const priceCalculationType = [
  "SHOP_BASED_COMMISSION",
  "CATEGORY_BASED_COMMISSION",
  "TP_BASED_COMMISSION",
];
export type BaggageAllowanceDescs = {
  ref: number
  id: number
  pieceCount: number
  unit: string | null
  weight: number | null
}
export type BaggageInformation = {
  airlineCode: string
  allowance: {
    ref: number
  } & BaggageAllowanceDescs
  provisionType: string
  segments: Segment
}
export type Equipment = {
  code: string
  typeForFirstLeg: string
  typeForLastLeg: string
}
export type Carrier = {
  alliances: string | null
  disclosure: string | null
  equipment: Equipment
  marketing: string
  marketingFlightNumber: number
  operating: string
  operatingFlightNumber: number
  //details?: CarrierBody // my custom added
}
export type Segment = {
  availabilityBreak: string | null
  bookingCode: string
  cabinCode: string
  mealCode: string
  seatsAvailable: number
  stopover: string | null
  surcharges: string | null
}
// get url query values
export const getQueryParams = () => {
  //legacy
  const obj = window.location.search
    .replace("?", "")
    .split("&")
    .reduce(
      (r: any, e: any) =>
        e
          ? ((r[e.split("=")[0]] = decodeURIComponent(e.split("=")[1])), r)
          : undefined,
      {}
    );
  return (obj && Object.keys(obj)?.length && obj) || {};
};

export const getUpdatedUrl = (key?: string, value?: any) => {
  // legacy, below is more dynamic
  const obj = window.location.search
    .replace("?", "")
    .split("&")
    .reduce((r: any, e: any): any => {
      return {
        [e.split("=")[0]]: encodeURIComponent(e.split("=")[1]),
      };
    }, {});
  const newObj = [];
  for (const [key2, value2] of Object.entries(obj)) {
    if (key2 && value2 && key2 !== key) {
      newObj.push({
        [key2]: value2,
      });
    }
  }
  if (key && value) {
    newObj.push({ [key]: value });
  }

  let str = "";
  for (const [key, value] of Object.entries(newObj)) {
    str += Object?.keys(value)?.[0] + "=" + Object.values(value)?.[0] + "&";
  }
  const newUrl = `${window.location.pathname}?${str.slice(0, str?.length - 1)}`;

  return newUrl;
};

export const jcTypeArray = [
  "JC_COMMERCE",
  "JC_MART",
  "JC_GROCERY",
  "JC_FOOD",
  "JC_MALL",
  "JC_GLOBAL",
  "JC_LANDING",
  "JC_CORPORATE",
  "JC_FASHION",
  "JC_MEDICINE",
  "JC_PARCEL",
  "JC_ELEARNING",
  "JC_B2B_COMMERCE",
  "JC_AFFILIATE",
];
export const jcCourierArray = [
  "E_COURIER",
  "PATHAO",
  "STEAD_FAST",
];
export const jcParcelTypeArray = [
  "BOX",
  "DOC",
];
export const jcBankTypeArray = [
  "NULL",
  "BANKING",
  "MOBILE_BANKING",
];

export const jcDayArray = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
];
export const baggageAllowanceUnit = [
  "KG",
  "PIC"
];
export const OrderTypeArray = [
  "PENDING",
  "INITIATED",
  "CONFIRMED_BY_CS",
  "REQUESTED_TO_MERCHANT",
  "REQUESTED_TO_DM",
  "PROCESSING",
  "ACCEPTED_BY_MERCHANT",
  "ACCEPTED_BY_DELIVERY_MAN",
  "READY_TO_PICKUP",
  "ON_DELIVERY",
  "PICKED",
  "DELIVERED",
  "COMPLETED",
  "REVIEWED",
  "CANCELLED",
];

export const MerchantOrderType = [
  "REQUESTED_TO_MERCHANT",
  "ACCEPTED_BY_MERCHANT",
  "READY_TO_PICKUP",
  // "ON_DELIVERY",
  // "DELIVERED",
  // "RETURN",
  // "CANCELLED",
];

export const MerchantOrderTypeArray = [
  "INITIATED",
  "REQUESTED_TO_MERCHANT",
  "ACCEPTED_BY_MERCHANT",
  "READY_TO_PICKUP",
  "ON_DELIVERY",
  "DELIVERED",
  "RETURN",
  "CANCELLED",
];

export const DmOrderTypeArray = [
  "INITIATED",
  "REQUESTED_TO_DM",
  "ACCEPTED_BY_DELIVERY_MAN",
  "PICKED",
  "DELIVERED",
  "COMPLETED",
  "REVIEWED",
  "CANCELLED",
];

export const MerchantStatus = [
  "WAITING_FOR_PERSONAL_DETAILS",
  "WAITING_FOR_BANK_INFO",
  "WAITING_FOR_STORE_INFO",
  "WAITING_FOR_WAREHOUSE_INFO",
  "WAITING_FOR_VERIFICATION",
  "VERIFIED",
];

export const MerchantProductStatus = ["APPROVED", "REJECTED", "REQUESTED"];
export const ProductStatus = ["WAITING_FOR_APPROVAL", "APPROVED", "REJECTED"];
export const ShopStatus = ["Open", "Close", "Busy"];

export const PrepareTime = [
  {
    label: "15 Min",
    value: 15,
  },
  {
    label: "30 Min",
    value: 30,
  },
  {
    label: "45 Min",
    value: 45,
  },
  {
    label: "60 Min",
    value: 60,
  },
];

export const DAYS = [
  {
    label: "Sun",
    value: "Sun",
  },
  {
    label: "Mon",
    value: "Mon",
  },
  {
    label: "Tue",
    value: "Tue",
  },
  {
    label: "Wed",
    value: "Wed",
  },
  {
    label: "Thu",
    value: "Thu",
  },
  {
    label: "Fri",
    value: "Fri",
  },
  {
    label: "Sat",
    value: "Sat",
  },
];

export const DriverStatus = [
  "VERIFIED",
  "PENDING",
  "SUSPEND",
  "WAITING_FOR_VERIFICATION",
];

export const promoUsedForArray = [
  "ALL_PRODUCTS",
  "NON_DISCOUNTED_PRODUCTS",
  "NON_EXCLUDED_PRODUCTS",
];
export const CampaignProductStatus = [
  "APPROVED",
  "REJECTED",
  "WAITING_FOR_APPROVAL",
];
export const RequestedProductStatus = [
  "REQUESTED",
  "APPROVED",
  "REJECTED",
  "WAITING_FOR_APPROVAL",
];
// export type FareComponentDescs = {
//   applicablePricingCategories: string
//   cabinCode: string
//   directionality: string
//   fareAmount: number
//   fareBasisCode: string
//   fareCurrency: string
//   farePassengerType: string
//   fareRule: string
//   fareTariff: string
//   fareType: string
//   fareTypeBitmap: string
//   governingCarrier: string
//   id: number
//   segments: Segment[]
//   vendorCode: string
// }
export type LegDescription = {
  arrivalLocation: string
  departureDate: string
  departureLocation: string
}
export type GroupDescription = {
  legDescriptions: LegDescription[]
}
export type ItineraryGroup = {
  groupDescription: GroupDescription
  itineraries: Itinerary[]
}
export type LegDescs = {
  elapsedTime: number
  id: number
  schedules: ScheduleDesc[]
  key: number
  ref: number
}
export type Arrival = {
  airport: string
  city: string
  country: string
  dateAdjustment: number
  terminal: string | null
  time: string
}
export type Departure = {
  airport: string
  city: string
  country: string
  time: string
  terminal: string | null
}
export type ScheduleDesc = {
  arrival: Arrival
  carrier: Carrier
  departure: Departure
  eTicketable: boolean
  elapsedTime: number
  eticketable: boolean
  frequency: string
  id: number
  stopCount: number
  totalMilesFlown: number
  ref: number
}
export type DiversitySwapper = {
  weighedPrice: number
}
export type Itinerary = {
  id: number
  pricingSource: string
  diversitySwapper: DiversitySwapper
  legs: LegDescs[]
  pricingInformation: PricingInformation[]
  fareSummary:any
}
export type CurrencyConversion = {
  exchangeRateUsed: number
  from: string
  to: string
}
export type FareComponentDescs = {
  applicablePricingCategories: string
  cabinCode: string
  directionality: string
  fareAmount: number
  fareBasisCode: string
  fareCurrency: string
  farePassengerType: string
  fareRule: string
  fareTariff: string
  fareType: string
  fareTypeBitmap: string
  governingCarrier: string
  id: number
  segments: Segment[]
  vendorCode: string
}
export type PassengerTotalFare = {
  baseFareAmount: number
  baseFareCurrency: string
  constructionAmount: number
  constructionCurrency: string
  currency: string
  equivalentAmount: number
  equivalentCurrency: string
  totalFare: number
  totalTaxAmount: number
}
export type PassengerInfo = {
  nonRefundable: boolean
  obFees: string
  passengerNumber: number
  passengerType: PassengerCodes
  baggageInformation: BaggageInformation[]
  currencyConversion: CurrencyConversion
  fareComponents: FareComponent[]
  passengerTotalFare: PassengerTotalFare
  taxSummaries: TaxSummary[]
  taxes: Taxe[]
}

export type Taxe = {
  ref: number
}
export type TaxSummary = {
  ref: number
}
export type PassengerInfoList = {
  passengerInfo: PassengerInfo
}
export type Fare = {
  airlineCode: string
  creationDetails: string
  eticketable: boolean | null
  fareCalculationLine: string | number
  fareConstruction: string | null
  governingCarriers: string
  lastTicketDate: string
  lastTicketTime: string
  negotiatedFare: boolean
  passengerInfoList: PassengerInfoList[]
  pricedTravelerType: string | null
  pricingStatusCode: string | null
  pricingStatusName: string | null
  pricingTypeCode: string | null
  pricingTypeName: string | null
  recordId: string | null
  recordTypeCode: string | null
  recordTypeName: string | null
  requestedTravelerType: string | null
  taxBreakdown: string | null
  totalFare: TotalFare
  totals: string | null
  validatingCarrierCode: string
  vita: boolean | null
}
export type PricingInformation = {
  pricingSubsource: string
  fare: Fare
}
export type TotalFare = {
  baseFareAmount: number
  baseFareCurrency: string
  constructionAmount: number
  constructionCurrency: string
  currency: string
  equivalentAmount: number
  equivalentCurrency: string
  totalPrice: number
  totalTaxAmount: number
}
export type FareComponent = {
  beginAirport: string
  endAirport: string
  ref: number
  segments: {
    segment: Segment
  }[]
}
export type Message = {
  code: string
  severity: string
  text: string
  type: string
}
export type ObFeeDescs = {
  amount: number
  currency: string
  id: number
}
export const ReturnOrderTypeArray = [
  "PENDING",
  "PICKED",
  "RECEIVED_AT_WAREHOUSE",
  "REJECTED",
  "CANCELLED",
  "COMPLETED",
];
export const groupStatus = ["INITIATED", "COMPLETED", "CANCELLED"];
export const imageOrderStatus = ["INITIATED", "PROCESSING"];
export type GroupedItineraryResponse = {
  baggageAllowanceDescs: BaggageAllowanceDescs[]
  fareComponentDescs: FareComponentDescs[]
  itineraryGroups: ItineraryGroup[]
  message: Message
  messages: Message[]
  obFeeDescs: ObFeeDescs[] | null
  scheduleDescs: ScheduleDesc[]
  statistics: Statistics
  statusCode: number | null
  taxDescs: TaxDesc[]
  taxSummaryDescs: TaxDesc[]
  legDescs: LegDescs[]
  version: string
}
export type TaxDesc = {
  amount: number
  code: string
  country: string
  currency: string
  description: string
  id: number
  publishedAmount: number
  publishedCurrency: string
  station: string
}
export type Statistics = {
  itineraryCount: number
}
export type SearchResponseType = {
  groupedItineraryResponse: GroupedItineraryResponse
  lowFareSearchId: string
  message?: string
  statusCode?: number
}

// export { CarrierBody };
